// extracted by mini-css-extract-plugin
export default {"container":"option_container__8w4i0"};